import API                          from '../../../../common/http/api.fetch';
import {success, responseMessage}   from '../../../../common/utils/util.notifier';
import I18N                         from '../../../../common/utils/util.i18n';
import { TYPES }                    from '../requirements-assessment-action-type.constants';
import { IDS }                      from '../requirements-assessment-action-id.constants';
import pick from "lodash/pick";
import {GRID_FETCH, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import {TAB_SELECT} from "../../../../common/tabs/tabs.constants";

// export const initReviewerStatuses = (statuses) => {
//     return dispatch => {
//         return dispatch({
//             type:   TYPES.INIT_REVIEW_STATUSES,
//             id:     IDS.accMasterDocList,
//             reviewStatuses: statuses.map(value => ({
//                 value, label: I18N.translate(`ACCREDITATION.REQUIREMENTS.DOCUMENT_STATUS.${value.toUpperCase()}`)
//             }))
//         })
//     }
// }

// export const setEvidenceGroupAssessment = (data) => {
//     return dispatch => {
//         return API.fetch({
//             url: `/rco/set-evidence-group-assessment`,
//             method: 'POST',
//             data,
//         }).then(response => {
//             success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
//         },error => {
//             responseMessage(error)
//         });
//     };
// };

export const fetchRequirementEvidenceGroupDocumentsGrid = params => {
    return dispatch => {
        if(!params.slo_uuid)
            return;
        return API.fetch({
            url: '/rco/list-requirement-evidence-group-documents-grid',
            method: 'GET',
            params,
        }).then(({data}) => {
            dispatch({
                type: GRID_FETCH,
                id: params.identifier,
                path: IDS.rcoEvidenceGroupDocumentsGrid,
                items: data.map(item => ({...item,
                    assessments: JSON.parse(item.assessments || '[]'),
                    doc_type_name: I18N.translate(`COMMON.DOCUMENT.CODE.${item.doc_type_code.toUpperCase()}`, item.doc_type_name)
                })),
            });
            // return data;
        }, error => {
            responseMessage(error);
        });
    };
}